import(/* webpackMode: "eager", webpackExports: ["RelativeDate"] */ "/app/apps/web/src/features/quick-create/components/relative-date.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/button.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/icon.tsx");
